import type { HTMLAttributes } from 'react';
import dynamic from 'next/dynamic';
import type { Props as ApexChartProps } from 'react-apexcharts';

// react-apexcharts types extra props as `[key: string]: any` and forwards them to its
// container <div>; type them as real div attributes so a misspelled prop fails to compile.
type ChartProps = Pick<ApexChartProps, 'type' | 'series' | 'width' | 'height' | 'options'> & Omit<HTMLAttributes<HTMLDivElement>, 'children'>;

export const Chart = dynamic<ChartProps>(() => import('react-apexcharts'), { ssr: false });
